import React from 'react';
import classNames from 'classnames';
import style from './App.less';

import { injectIntl } from 'react-intl';
import { inject, toggleInject } from "../components/injector";


class Error2 extends React.PureComponent {
    componentDidMount(){
        document.title = this.props.intl.formatMessage({ id: 'faultTitle' })
    }
    strs = (id) => {
        const { formatMessage } = this.props.intl;
        const data = formatMessage({ id: id });
        return data.replace(/(\r\n)|(\n)/g, '<br/>');
    };

    render() {
        const { pwr, intl, history } = this.props;
        return (
            <div className={style.errorPage}>
            <div className={style.errorTitle}>{intl.formatMessage({ id: 'error2Title' })}</div>
            <div className={style.errorContent}>
                <div className={style.errorDesc}>{intl.formatMessage({ id: 'error1desc' })}</div>
                <table>
                    <tbody>
                        <tr>
                            <td>{intl.formatMessage({ id: 'errorReason' })}</td>
                            <td>{intl.formatMessage({ id: 'resolvent' })}</td>
                        </tr>
                        <tr>
                            <td>{intl.formatMessage({ id: 'error2A' })}</td>
                            <td>{intl.formatMessage({ id: 'error2AMethod' })}</td>
                        </tr>
                        <tr>
                            <td>{intl.formatMessage({ id: 'error2B' })}</td>
                            <td>{intl.formatMessage({ id: 'error2BMethod' })}</td>
                        </tr>
                        <tr>
                            <td>{intl.formatMessage({ id: 'error2C' })}</td>
                            <td>{intl.formatMessage({ id: 'error2CMethod' })}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        )
    }
}



export default inject()(injectIntl(Error2));